import React from "react";
import styled from "styled-components";
import { spacing, textStyle } from "../../dimensions";
import { ArrowTopRightIcon, BoxOfficeIcon, CheckmarkCircledFilledIcon, PostalTicketIcon, PrinterIcon, TicketErrorIcon, TicketMobileIcon, ArrowsRefreshIcon, ExclamationMarkTriangleFilledIcon, InfoICircledFilledIcon } from "../../icons";
export var Stack = styled.div.withConfig({
  displayName: "TicketDescription__Stack",
  componentId: "sc-144azgr-0"
})(["display:flex;flex-direction:column;gap:", ";align-items:center;align-self:stretch;justify-content:center;"], spacing.hall);
export var CopyWrapper = styled.div.withConfig({
  displayName: "TicketDescription__CopyWrapper",
  componentId: "sc-144azgr-1"
})(["display:flex;flex-direction:column;gap:", ";align-items:center;align-self:stretch;"], spacing.lounge);
export var Title = styled.h2.withConfig({
  displayName: "TicketDescription__Title",
  componentId: "sc-144azgr-2"
})(["margin:0px;color:", ";", ""], function (props) {
  return props.theme.text.primary;
}, textStyle.nevis);
export var Description = styled.p.withConfig({
  displayName: "TicketDescription__Description",
  componentId: "sc-144azgr-3"
})(["margin:0px;color:", ";", " text-align:center;"], function (props) {
  return props.theme.text.secondary;
}, textStyle.etna);
var ICONS = {
  postal: /*#__PURE__*/React.createElement(PostalTicketIcon, null),
  willCall: /*#__PURE__*/React.createElement(BoxOfficeIcon, null),
  print: /*#__PURE__*/React.createElement(PrinterIcon, null),
  transferComplete: /*#__PURE__*/React.createElement(CheckmarkCircledFilledIcon, {
    fillColor: "success"
  }),
  cancelled: /*#__PURE__*/React.createElement(TicketErrorIcon, null),
  appOnly: /*#__PURE__*/React.createElement(TicketMobileIcon, null),
  resaleSold: /*#__PURE__*/React.createElement(CheckmarkCircledFilledIcon, {
    fillColor: "success"
  }),
  transferPending: /*#__PURE__*/React.createElement(ArrowTopRightIcon, {
    fillColor: "primary"
  }),
  resale: /*#__PURE__*/React.createElement(ArrowsRefreshIcon, {
    fillColor: "resale"
  }),
  error: /*#__PURE__*/React.createElement(ExclamationMarkTriangleFilledIcon, {
    fillColor: "warning"
  }),
  info: /*#__PURE__*/React.createElement(InfoICircledFilledIcon, {
    fillColor: "info"
  })
};
var TicketDescription = function TicketDescription(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
var Header = function Header(_ref2) {
  var children = _ref2.children,
    icon = _ref2.icon;
  return /*#__PURE__*/React.createElement(Stack, null, ICONS[icon], /*#__PURE__*/React.createElement(CopyWrapper, null, children));
};
TicketDescription.Header = Header;
TicketDescription.Title = Title;
TicketDescription.Description = Description;
export default TicketDescription;